/** 同一场会议才复用识别实例。appId 变了就必须丢掉上一场。 */
export function reuseSpeechSession(boundAppId: string, nextAppId: string): boolean {
  return Boolean(nextAppId) && boundAppId === nextAppId
}
